import { fromZonedTime } from 'date-fns-tz';
import { useEffect, useState } from 'react';

// helpers
import {
  Duration,
  pad,
  getColorFromDuration,
  Props,
  msToDuration,
  ZONE_BY_COUNTRY,
} from './helpers/durationUtils';

export const LiveDurationTask = ({ startAt, country }: Props) => {
  const zone = ZONE_BY_COUNTRY[country];
  const startDate = fromZonedTime(startAt, zone);
  const startMs = startDate.getTime();

  const [duration, setDuration] = useState<Duration>(() =>
    msToDuration(Date.now() - startMs)
  );
  const [diffMs, setDiffMs] = useState<number>(() => Date.now() - startMs);

  useEffect(() => {
    if (!startAt) return;

    const id = setInterval(() => {
      const now = Date.now();
      const diff = now - startMs;
      setDiffMs(diff);
      setDuration(msToDuration(diff));
    }, 1000);

    return () => clearInterval(id);
  }, [startAt, country]);

  const timeString = `${pad(duration.hours)}:${pad(duration.minutes)}:${pad(
    duration.seconds
  )}`;
  const color = getColorFromDuration(diffMs);

  return (
    <div style={{ color, fontWeight: 'bold' }}>
      {duration.days > 0 ? `${duration.days}d ` : ''}
      {timeString}
    </div>
  );
};
